import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API } from '../../services/api';
const api = new API();

import { changeItemOwner } from '../itemOwner/itemOwnersSlice';
import { saveTreadPublished, publishTread } from '../tread/treadSlice';

export const fetchTreads = createAsyncThunk(
  'treads/get',
  async (data, thunkAPI) => {
    try {
      const response = await api.getTreads(data.ownerId);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: treads/get', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

const initialState = {
  treads: [],
  status: 'idle',
  error: null
};


export const treadsSlice = createSlice({
  name: 'treads',
  initialState,
  reducers: {
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchTreads.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.error = null;
      state.treads = action.payload.treads || [];
    },
    [fetchTreads.pending]: (state, action) => {
      state.status = 'loading',
      state.error = null;
    },
    [fetchTreads.rejected]: (state, action) => {
      state.status = 'failed';
      state.error = {
        message: action.payload.messages.join(', ')
      };
    },

    [changeItemOwner.fulfilled]: (state, action) => {
      // Clear state if owner changes
      return initialState;
    },

    [saveTreadPublished.fulfilled]: (state, action) => {
      // Update list when item family is saved (published version)
      const index = state.treads.findIndex(fam => fam.code === action.payload.code);
      state.treads[index] = action.payload;
    },

    [publishTread.fulfilled]: (state, action) => {
      // Update list when item family is saved (published version)
      const index = state.treads.findIndex(fam => fam.code === action.payload.code);
      state.treads[index] = action.payload;
    },
  }
});

export const selectTreads = state => state.treads;

export default treadsSlice.reducer;
